import {combineReducers} from 'redux'
import createLoggedInUserReducer from '../loggedInUser/reducer'
import createEntitiesReducer from '../entities/reducer'
import createAssignmentsReducer from '../assignments/reducer'
import createTaskManagementReducer from '../taskManagement/reducer'
import createPanelsReducer from '../panels/reducer'
import workflowSettings from '../administration/workflowSettings/reducer'
import createDARSettingsReducer from '../administration/darSettings/reducer'
import createUserManagementReducer from '../administration/userManagement/reducer'
import createFeaturesReducer from '../features/reducer'
import createUserProfileReducer from '../userProfile/reducer'
import createReportsReducer from '../reports/reducer'
import createLockoutPolicyReducer from '../administration/lockoutPolicy/reducer'
import createPasswordReducer from '../administration/passwordSettings/reducer'
import createMailReducer from '../administration/mailSettings/reducer'
import toasts from '../toasts/reducer'
import createWorkScheduleReducer from '../administration/workSchedule/workScheduleReducer'
import createActiveLicenseInfoReducer from '../activeLicenseInfo/reducer'
import createSupportReducer from '../support/supportForm/reducer'
import createWelcomeReducer from '../support/welcomeScreen/reducer'
import createAddonsReducer from '../support/addons/reducer'

export default (initAppData) => {
    return combineReducers({
        loggedInUser: createLoggedInUserReducer(initAppData),
        entities: createEntitiesReducer(initAppData),
        assignments: createAssignmentsReducer(initAppData),
        taskManagement: createTaskManagementReducer(initAppData),
        panels: createPanelsReducer(initAppData),
        userProfile: createUserProfileReducer(initAppData),
        workflowSettings,
        darSettings: createDARSettingsReducer(initAppData),
        lockoutPolicy: createLockoutPolicyReducer(initAppData),
        passwordSettings: createPasswordReducer(initAppData),
        mailSettings: createMailReducer(initAppData),
        userManagement: createUserManagementReducer(initAppData),
        features: createFeaturesReducer(initAppData),
        reports: createReportsReducer(initAppData),
        workSchedule: createWorkScheduleReducer(initAppData),
        toasts,
        activeLicenseInfo: createActiveLicenseInfoReducer(initAppData),
        support: createSupportReducer(initAppData),
        addons: createAddonsReducer(initAppData),
        welcome: createWelcomeReducer(initAppData),
    })
}



// WEBPACK FOOTER //
// ./web/js/redux/reducer.js